export const isRelativeUrl = (url?: string) => {
  return url ? url.charAt(0) === '/' : false;
};
